import React, { ChangeEvent, FC } from 'react';
import { windowService } from '../../../../utils/window.utils.js';
import { TLanguagesProps } from '../../types/lightHeader.types';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';

const LanguageSelector: FC<TLanguagesProps> = ({ items }) => {
  const redirectToTargetUrl = (url): void => {
    const urlIsValid = !!items?.find((item) => item?.fields?.url?.value?.href === url);

    if (urlIsValid) {
      windowService()?.location.assign(url);
    }
  };

  const onChange = (evt: ChangeEvent<HTMLSelectElement>): void => redirectToTargetUrl(evt?.target?.value);
  const options = items?.map((item) => (
    <option key={item?.id} className="lightheader-language-selector__option" value={item?.fields?.url?.value?.href}>
      {item?.fields?.url?.value?.text}
    </option>
  ));

  return (
    <div className="lightheader-language-selector">
      <Icon extraClassName="lightheader-language-selector__left-icon" iconName="action-flag" size={iconSize.mbl} />
      <select className="lightheader-language-selector__select" onChange={onChange}>
        {options}
      </select>
      <Icon extraClassName="lightheader-language-selector__right-icon" iconName="arrow-chevron-down" size={iconSize.mbl} />
    </div>
  );
};

export default LanguageSelector;
